export default __webpack_public_path__ + "static/media/Cleave of the Northern Wastes.0efbd014.jpg";